export const enum PayoutStatus {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    PROCESSING = 'PROCESSING',
    PENDING = 'PENDING',
    QUEUING = 'QUEUING',
    READY_TO_PAY = 'READY_TO_PAY',
    UNPAID = 'UNPAID',
    INITIAL = 'INITIAL',
    BLOCKED = 'BLOCKED',
    PARTIALLY_SUCCESS = 'PARTIALLY_SUCCESS',
    DERECOGNIZED = 'DERECOGNIZED',
    UNDEFINED = 'UNDEFINED',
}

export const enum PayoutMethod {
    PAYPAL = 'PAYPAL',
    PAYONEER = 'PAYONEER',
    JPMORGAN = 'JPMORGAN',
    TIPALTI = 'TIPALTI',
    WIRE = 'WIRE',
    CHEQUE = 'CHEQUE',
}

export const enum PayoutStatusLabel {
    FAILED_LABEL = 'The payout was attempted by Udemy but was not delivered. See the troubleshooting steps for actions you can take to resolve this.',
    PROCESSING_LABEL = 'The payout is currently being processed.',
    QUEUING_LABEL = 'Your payout is in the queue. We will attempt to process it in at most 14 days.',
    READYTOPAY_LABEL = 'Your payout is in the queue. We will attempt to process it in at most 14 days.',
    SUCCESS_LABEL = `We successfully sent your payout. It might take more time for your banking provider to fund your account.`,
    PARTIALLY_SUCCESS_LABEL = `We sent part of your payout successfully. Some amounts couldn’t be processed and may require further action.`,
    BLOCKED_LABEL = `The payout is currently blocked.`,
    UNPAID_LABEL = 'The payout has been cancelled or resent with a new payout.',
    UNDEFINED_LABEL = 'The status of your payout is not defined in our system, which can occur with certain payout methods.',
    DERECOGNIZED_LABEL = 'This payout was derecognized and the funds will not be transferred to your account.',
}
